import { useEffect, useState } from "react";
import { Dashboard } from "../../components/Dashboard";
import { CouponList } from "../../components/CoupanList";
import { CouponForm } from "../../components/CoupanForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { CallAPIDeletePromise, CallAPIGetPromise, CallAPIPostPromise } from "Common/commaon";
import "./coupon-dashboard.css";
export interface Coupon {
  id: string;
  title: string;
  coupon_code: string;

  minAmount: any;
  maxAmount: any;
  minSpend: any;

  expiryDate: string;

  status: "active" | "inactive" | "expired";
  activationStatus: string;

  isNew: any;

  termsAndConditions: string;

  maxUsage: any;

  imageUrl: string;

  forUsers: string;

  createdAt: string;
  updatedAt: string;

  daysLeft: number;
}
export default function CoupanDashboard() {

  const [activeTab, setActiveTab] = useState("dashboard");
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [couponsAdmin, setCouponsAdmin] = useState<any>([]);
  const [editingCoupon, setEditingCoupon] = useState<Coupon | null>(null);
  const [refresh,setRefresh]=useState(false)
  const handleAddCoupon = (coupon: Omit<Coupon, "id" | "usageCount">) => {
    CallAPIPostPromise("/coupan", coupon);
    setRefresh(r=>!r)
 
  };

  const handleUpdateCoupon = (updatedCoupon: Coupon) => {
    CallAPIPostPromise("/coupan", updatedCoupon);

    setRefresh(r=>!r)

    setEditingCoupon(null);
    setActiveTab("coupons");
  };

  const handleDeleteCoupon = (id: string) => {

    CallAPIDeletePromise(`/coupan/${id}`);
    setRefresh(r=>!r)

  };

  const handleEditCoupon = (coupon: Coupon) => {
    setEditingCoupon(coupon);
    setActiveTab("create"); // 👈 switch tab
  };

  useEffect(() => {
    CallAPIGetPromise("/coupan").then((res: any) => {
      if (res?.success) {
        setCoupons(res.data.coupons);
      }
    });
  }, [refresh]);

  useEffect(() => {
    CallAPIGetPromise("/admin/coupons").then((res: any) => {
      if (res?.success) {
        setCouponsAdmin(res.data);
      }
    });
  }, [refresh]);

  return (
    <div className="tailwind-prefix page-content coupon-dashboard-page">
      <div className="coupon-dashboard-shell">

        <Tabs value={activeTab} onValueChange={setActiveTab} className="coupon-dashboard-tabs-root w-full">

          <TabsList className="coupon-dashboard-tabs" aria-label="Coupon management sections">

            <TabsTrigger value="dashboard" className="coupon-dashboard-tab border-0">
              Dashboard
            </TabsTrigger>

            <TabsTrigger value="coupons" className="coupon-dashboard-tab border-0">
              Coupons
            </TabsTrigger>

            <TabsTrigger value="create" className="coupon-dashboard-tab border-0">
              Create
            </TabsTrigger>

          </TabsList>

          <TabsContent value="dashboard" className="coupon-dashboard-content">
            <Dashboard coupons={couponsAdmin} />
          </TabsContent>

          <TabsContent value="coupons" className="coupon-dashboard-content">
            <CouponList
              coupons={coupons}
              onDelete={handleDeleteCoupon}
              onEdit={handleEditCoupon}
            />
          </TabsContent>

          <TabsContent value="create" className="coupon-dashboard-content">
            <CouponForm
              onSubmit={editingCoupon ? handleUpdateCoupon : handleAddCoupon}
              editingCoupon={editingCoupon}
              onCancel={() => {
                setEditingCoupon(null);
                setActiveTab("coupons");
              }}
            />
          </TabsContent>

        </Tabs>
      </div>
    </div>
  );
}
